import { Row } from '@tanstack/react-table';

export const formatPrice = (value: string | number) => Number(value).toFixed(2);

// API serializes decimals as strings; default sorters compare them alphanumerically
export const numericSort = <T,>(rowA: Row<T>, rowB: Row<T>, columnId: string) =>
  Number(rowA.getValue(columnId)) - Number(rowB.getValue(columnId));
